import { logError } from '@ardoq/logging';
import { GridApi } from 'ag-grid-enterprise';

import { ArdoqId } from '@ardoq/api-types';
import { isArdoqError } from '@ardoq/common-helpers';
import { createComponentsOperations } from './createComponents/createComponentsOperations';
import { InventoryCommands } from './types';
import { inventoryGridAPIOperations } from './inventoryGridAPIOperations';

const deleteComponentAndRemoveFromGrid = async (
  deletedComponentId: ArdoqId,
  gridApi: GridApi,
  commands: InventoryCommands
) => {
  const isComponentPersisted =
    !createComponentsOperations.isComponentNotPersisted(deletedComponentId);
  if (isComponentPersisted) {
    const result = await commands.deleteComponents([deletedComponentId]);
    if (isArdoqError(result)) {
      logError(result.error, 'Error deleting components');
      return;
    }
    inventoryGridAPIOperations.removeComponentsFromPinnedRows(
      gridApi,
      result.componentIds
    );
  } else {
    inventoryGridAPIOperations.removeComponentsFromPinnedRows(gridApi, [
      deletedComponentId,
    ]);
  }
};

export const asyncManageComponentsCallbacks = {
  deleteComponentAndRemoveFromGrid,
};
